import { useState } from "react";

export interface UseArpsUploadWizardReturn {
  isWizardOpen: boolean;
  selectedFolderId: string | null;
  selectedFolderName: string | null;
  files: File[] | null;
  initialError: string | null;
  initialErrorInstructions: string | null;
  openWizard: (
    folderId: string,
    folderName: string,
    files?: File[],
    options?: {
      initialError?: string | null;
      initialErrorInstructions?: string | null;
    }
  ) => void;
  closeWizard: () => void;
}

export function useArpsUploadWizard(): UseArpsUploadWizardReturn {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
  const [selectedFolderName, setSelectedFolderName] = useState<string | null>(null);
  const [files, setFiles] = useState<File[] | null>(null);
  const [initialError, setInitialError] = useState<string | null>(null);
  const [initialErrorInstructions, setInitialErrorInstructions] = useState<string | null>(
    null
  );

  const openWizard = (
    folderId: string,
    folderName: string,
    uploadFiles?: File[],
    options?: {
      initialError?: string | null;
      initialErrorInstructions?: string | null;
    }
  ) => {
    setSelectedFolderId(folderId);
    setSelectedFolderName(folderName);
    setFiles(uploadFiles || null);
    setInitialError(options?.initialError ?? null);
    setInitialErrorInstructions(options?.initialErrorInstructions ?? null);
    setIsWizardOpen(true);
  };

  const closeWizard = () => {
    setIsWizardOpen(false);
    setSelectedFolderId(null);
    setSelectedFolderName(null);
    setFiles(null);
    setInitialError(null);
    setInitialErrorInstructions(null);
  };

  return {
    isWizardOpen,
    selectedFolderId,
    selectedFolderName,
    files,
    initialError,
    initialErrorInstructions,
    openWizard,
    closeWizard
  };
}
